import * as D from './deps';
import KruxWatchers from './sagas/watchers';

export default D.createDomainModule({
  name: 'krux',
  actions: null,
  reducer: null,
  constants: null,
  selectors: null,
  components: {},
  onLoad() {},
  onStart() {
    this.registeredHandlers = D.registerHandlers(KruxWatchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
